<template>
	<div>
		<section class="filters">
			<div class="container">
				<h3 @click="openFilters = !openFilters" class="filters__headline">{{$t('filters.narrow')}}
					<img class="filters__arrow" :class="{'filters__arrow--close': openFilters}" src="../../../static/img/mobile-arrow-down.png" alt="">
				</h3>
				<div class="row" :class="{close: !openFilters}">
					<RankFilterComponent :openFilters="openFilters"></RankFilterComponent>
					<CountryFilterComponent></CountryFilterComponent>
					<DistanceFilterComponent></DistanceFilterComponent>
					<VueDatepickerLocal v-model="range" clearable show-buttons
										@confirm="getRange(date)"
										@removeRange="removeRange()"
										:placeholder="$t('filters.date')"
					/>
					<BreedsFilterComponent></BreedsFilterComponent>
					<NameFilterComponent></NameFilterComponent>
				</div>
			</div>
		</section>

		<!-- selected filters -->
		<section class="selected">
			<div class="container">
				<div class="row">
					<div v-if="$store.getters.isAnyFilterSelected" class="col-sm-12 col-md-2 col-lg-1">
						<span class="selected__label">
							{{ $t('filters.buttonResultsName') }}
						</span>
					</div>

					<div v-else class="selected__label-wrapper col-sm-12 col-md-12 col-lg-1">
						<span class="selected__label selected__label--no-filters">
							{{ $t('filters.buttonNoResultsName') }}
						</span>
					</div>

					<div class="col-sm-12 col-md-10 col-lg-11">
						<div class="selected__filters">
							<span
								v-if="$store.state.events.activeRank"
								class="selected__filter"
								@click="removeRankFilter"
							>
								{{ $store.state.events.activeRank }}
								<img src="/static/img/close.svg" alt="">
							</span>

							<span
								v-for="country in $store.getters.activeCountries"
								class="selected__filter"
								@click="removeCountryFilter(country)"
							>
								{{ country.name }}
								<img src="/static/img/close.svg" alt="">
							</span>

							<span
								v-if="$store.state.events.distance"
								class="selected__filter"
								@click="removeDistanceFilter($store.state.events.distance)"
							>
								{{ $store.state.events.distance }} km
								<img src="/static/img/close.svg" alt="">
							</span>

                            <span
                                v-if="$store.state.events.activeCity"
                                class="selected__filter"
                                @click="deleteCity"
                            >
								{{ $store.state.events.activeCity }}
								<img src="/static/img/close.svg" alt="">
							</span>

                            <span
                                    v-if="$store.state.events.dateText"
                                    class="selected__filter"
                                    @click="removeRange"
                            >
								{{ $store.state.events.dateText }}
								<img src="/static/img/close.svg" alt="">
							</span>

							<span
								v-for="breed in $store.getters.activeBreeds"
								class="selected__filter"
								@click="removeBreedFilter(breed)"
							>
								{{ breed.name }}
								<img src="/static/img/close.svg" alt="">
							</span>

                            <span
                                v-for="name in $store.state.events.activeNames"
                                class="selected__filter"
                                @click="removeNameFilter(name)"
                            >
								{{ name.full_name }}
								<img src="/static/img/close.svg" alt="">
							</span>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- e/o selected filters -->

	</div>
</template>

<script>
	import RankFilterComponent from './Filters/RankFilterComponent'
	import CountryFilterComponent from './Filters/CountryFilterComponent'
	import DistanceFilterComponent from './Filters/DistanceFilterComponent'
	import BreedsFilterComponent from './Filters/BreedsFilterComponent'
	import NameFilterComponent from './Filters/NameFilterComponent'
	import VueDatepickerLocal from '@/components/EventsList/Filters/VueDatepickerLocal'
	import { mapActions } from 'vuex'

	export default {
		components: {
			RankFilterComponent,
			DistanceFilterComponent,
			CountryFilterComponent,
			BreedsFilterComponent,
			NameFilterComponent,
			VueDatepickerLocal
		},
		data () {
			return {
				openFilters: false,
				checkbox: [],
				range: [],
				date: {
					startDate: '',
					endDate: ''
				}
			}
		},
		watch: {
			range (val) {
				if (val.length !== 0) {
					const startDay = val[0].getDate() < 10 ? `0${ val[0].getDate() }` : val[0].getDate()
					const endDay = val[1].getDate() < 10 ? `0${ val[1].getDate() }` : val[1].getDate()
					const startMonth = val[0].getMonth() + 1 < 10 ? `0${ val[0].getMonth() + 1 }` : val[0].getMonth() + 1
					const endMonth = val[1].getMonth() + 1 < 10 ? `0${ val[1].getMonth() + 1 }` : val[1].getMonth() + 1
					this.date.startDate = `${ val[0].getFullYear() }-${ startMonth }-${ startDay }`
					this.date.endDate = `${ val[1].getFullYear() }-${ endMonth }-${ endDay }`
				}
			},
			'$route.query' () {
				this.$store.commit('setRouteParams', this.$route.query)
				// this.$router.replace('/wydarzenia')
			}
		},
		methods: {
			...mapActions(['fetchEvents']),
			closeFiltersLists (e) {
				const open = document.querySelector('.open')
				if (open && !e.target.matches('.filter__list, .filter__list *') && !e.target.matches('.close, .close *') && !e.target.matches('.open, .open *')) {
					this.showList = ''
				}
			},
			removeRankFilter (item) {
				this.$store.commit('removeRank', item)
				this.fetchEvents()
			},
			removeCountryFilter (item) {
				this.$store.commit('removeEventsCountry', item.code)
				this.fetchEvents()
			},
			removeNameFilter (item) {
				this.$store.commit('removeJudgeName', item)
				this.fetchEvents()
			},
			removeBreedFilter (item) {
				this.$store.commit('removeBreed', item.id)
				this.fetchEvents()
			},
			removeDistanceFilter () {
				this.$store.commit('removeCity')
				this.fetchEvents()
			},
			deleteCity () {
				const inputs = document.querySelectorAll('.city-input')
				inputs.forEach(input => {
					input.value = ''
				})
				this.$store.commit('removeCity')
				this.fetchEvents()
			},
			getRange (item) {
				this.$store.commit('setRange', item)
				this.fetchEvents()
			},
			removeRange () {
				this.$store.commit('resetRange')
				this.$store.commit('updateDateText')
				this.fetchEvents()
			}
		},
		created () {
			document.addEventListener('click', this.closeFiltersLists)
			this.$store.commit('setRouteParams', this.$route.query)
			const countryItem = this.$store.state.events.routeParams.country

			if (countryItem) {
				this.$store.commit('addEventsCountry', countryItem)
			}
			const breedItem = +this.$store.state.events.routeParams.breed
			if (breedItem) {
				this.$store.commit('addBreed', breedItem)
			}
			this.fetchEvents()
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../styles/variables.scss";

	.close {
		display: flex;
	}

	.filters {
		padding: 25px 0;
		background-color: #aa9f8b;
		&__headline {
			text-align: left;
			font-size: 14px;
			font-family: $lato-bold;
			text-transform: uppercase;
			margin: 0 0 15px;

			display: flex;
			align-items: center;
		}
		&__arrow {
			display: none;
			margin-left: 5px;
		}
	}

	.selected {
		padding: 40px 0 0;
		background-color: $gray-light;
		&__label-wrapper {
			display: none;
		}
		&__label {
			text-transform: uppercase;
			display: block;
			width: 100%;
			max-width: 80px;
			height: 40px;
			background-color: $gold;
			font-family: $lato-bold;
			font-size: 13px;
			color: #fff;
			padding: 12px 0;
		}
		&__filters {
			display: flex;
			flex-wrap: wrap;
		}
		&__filter {
			cursor: pointer;
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 15px;
			margin-right: 20px;
			margin-bottom: 20px;
			min-width: 170px;
			height: 40px;
			background-color: #fff;
			font-size: 14px;
			color: $gray-filter;
			img {
				margin-left: 10px;
			}
		}
	}

	@media (max-width: 991.98px) {
		.filters {
			padding: 20px 0 10px;
			&__arrow {
				display: inline-block;
				&--close {
					transform: rotate(180deg);
				}
			}
		}
		.selected {
			padding: 20px 0 0;
			&__label-wrapper {
				display: block;
			}
			&__label {
				max-width: 80px;
				margin-bottom: 20px;
				&--no-filters {
					max-width: max-content;
					padding: 20px;
					height: auto;
				}
			}
			&__filter {
				margin-right: 10px;
				margin-bottom: 15px;
				min-width: 130px;
				font-size: 13px;
			}
		}
		.close {
			display: none;
		}
	}

	// Small devices (landscape phones, 576px and up)
	@media (min-width: 576px) and (max-width: 767.98px) {

	}

	// Medium devices (tablets, 768px and up)
	@media (min-width: 768px) and (max-width: 991.98px) {

	}

	// Large devices (desktops, 992px and up)
	@media (min-width: 992px) and (max-width: 1199.98px) {
	}

	// Extra large devices (large desktops, 1200px and up)
	@media (min-width: 1200px) {
	}
</style>



// WEBPACK FOOTER //
// src/components/EventsList/FiltersComponents.vue